export const gaWork = {
    cut: "fromCut",
    speed: "fromSpeed",
    merge: "fromMerge",
    removeWatermark: "fromWatermarkRemover",
    addWatermark: 'fromaddWatermark',
    reverse: "fromReverse",
    loop: "fromLoop",
    crop_rotate: "fromCrop&Rotate",
    subtitle: "fromSubtitles",
    resize: "fromResize",
    addMusic: "fromAddMusic"
}